import DoneIcon from "@mui/icons-material/Done";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import GlobalButton from "../../../components/CustomButton";
import appcolors from "../../../constants/Colors";

const style = {
  cardFront: {
    perspective: "s1000px",
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    border: "2px solid #E7E9ED",
  },
  cardBack: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#fff",
    border: "2px solid #E7E9ED",
  },

  dollarIcon: {
    fontWeight: 600,
    fontSize: "1.5rem",
    color: appcolors.black,
    fontFamily: "GiloryBold",
  },
  price: {
    fontWeight: 600,
    fontSize: "3.5rem",
    color: appcolors.black,
    fontFamily: "GiloryBold",
    padding: 1,
  },
  duration: {
    fontWeight: 300,
    fontSize: "1rem",
    color: appcolors.black,
    marginLeft: 4,
  },
};

function PlansCard(props) {
  const { val, index, handleClickBtn } = props;

  return (
    <Grid key={index} item xs={12} sm={6} md={3}>
      <Box sx={style.cardFront}>
        <Box p={2}>
          <Typography
            variant="h3"
            color={"#473BF0"}
            fontSize={"0.875rem"}
            textTransform={"uppercase"}
          >
            {val.name}
          </Typography>

          <Typography mt={2} variant="h1" style={style.price}>
            <span style={style.dollarIcon}>SAR</span>
            {val.price}
            <span style={style.duration}>/monthly</span>
          </Typography>
          <Typography variant="body1" fontFamily={"GiloryLight"}>
            billed monthly
          </Typography>

          <List sx={{ m: "20px 0" }}>
            {val.features.map((item, ind) => {
              const listIcon = (
                <DoneIcon htmlColor="#68D585" sx={{ fontSize: "1.3rem" }} />
              );
              return (
                <ListItem key={ind} sx={{ padding: "2px 0px" }}>
                  <ListItemIcon sx={{ minWidth: 25 }}>{listIcon}</ListItemIcon>
                  <ListItemText
                    sx={{
                      "& .MuiListItemText-secondary": {
                        color: "#161C2D",
                      },
                    }}
                    secondary={item}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
        <Box height={50} width={"90%"} p={2}>
          <GlobalButton
            variant={"contained"}
            btnText={"Buy Now"}
            styleProps={{ fontWeight: 400 }}
            handleClickBtn={() => handleClickBtn(val)}
          />
        </Box>
      </Box>
    </Grid>
  );
}

export default PlansCard;
